import BoxContent from "./BoxContent";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import React from "react";
import ScrollBar from "./ScrollBar";
import {MathJax} from "better-react-mathjax";
import FormLabelBox from "./FormLabelBox";
import FormFieldBox from "./FormFieldBox";
import {Chip} from "@mui/material";

export const AnswerChip = ({item}: any) => {
    const getTitle = () => {
        if (item.is_not_answered) {
            return "Omis";
        }
        if (item.is_wrong_answer) {
            return "Greșit";
        }
        if (item.is_right_answer) {
            return "Corect";
        }
        if (item.not_paying_atention) {
            return "Din neatenție";
        }
        return null;
    }

    const getColor = () => {
        if (item.is_not_answered) {
            return "default";
        }
        if (item.is_wrong_answer) {
            return "error";
        }
        if (item.is_right_answer) {
            return "success";
        }
        if (item.not_paying_atention) {
            return "warning";
        }
        return "default";
    }

    return (
        <Chip
            label={getTitle()}
            size="small"
            color={getColor()}
            variant="filled"
            sx={{fontSize: "0.75rem", height: 22}}
        />
    );
}

export const getDifficulty = (difficulty: any) => {
    const getColor = () => {
        switch (difficulty) {
            case "Ușor":
                return "success";
            case "Mediu":
                return "warning";
            case "Dificil":
                return "error";
            default:
                return "default";
        }
    }
    return (
        <Chip
            label={`Dificultate: ${difficulty}`}
            size="small"
            color={getColor()}
            variant="outlined"
            sx={{fontSize: "0.75rem", height: 22}}
        />
    )
}

const ShowScrollBar = ({isVisible, children} : any) => {
    return (
        isVisible ? (
            <ScrollBar
                forceVisible="x"
                autoHide={false}
                style={{
                    maxHeight: "100%",
                    maxWidth: "100%",
                    overflowY: "hidden",
                }}
            >
                {children}
            </ScrollBar>
            ) : (
             <>
                 {children}
             </>
        )

    )
}

const ResponseCard = ({response, question, isAnswerReport, testMode, hasBg}: any) => {
    return (
        <Box
            key={response.letter ?? response.response}
            mb={1}
            sx={{
                padding: 1,
                border: "1px solid",
                borderColor: !hasBg ? "background.paper" : "#fff",
                borderRadius: "5px",
                borderLeft: isAnswerReport && ((testMode !== 5 && question.right_answer === response.letter) ||
                (question.user_answer === response.letter && question.is_right_answer))
                    ? "3px solid #00BA3B"
                    : isAnswerReport && question.user_answer === response.letter && !question.is_right_answer
                        ? "3px solid #9D0000"
                        : hasBg ? "1px solid #fff" : "1px solid #D7E6FF",
            }}
            width="100%"
        >
            <Typography
                variant="body2"
                component="div"
                dangerouslySetInnerHTML={{ __html: response.response ?? response }}
            />
        </Box>
    )
}

const TestItemCard = ({
    question,
    testId,
    difficulty,
    isAnswerReport,
    isCustomItemPreview = false,
    isCustomItemPreviewTest = false,
    testMode,
    isPrinting,
    hasBg = false,
} : any) => {

    const showEnunciation = question.enunciation || (question.q_data && testMode === 7 && (isCustomItemPreview || isCustomItemPreviewTest)) || (question.q_obs && testMode === 5);
   const showRequirement = question.question || (question.q_obs && (isCustomItemPreview || isCustomItemPreviewTest));

    return (
        <Box width="100%" sx={{ my: { xs: 1, md: 2 } }}>
            <BoxContent sxExtra={{
                boxSizing: "border-box",
                backgroundColor: isPrinting || !hasBg ? "transparent" : "background.paper",
                border: isPrinting || !hasBg ? "1px solid" : "none",
                borderColor: isPrinting || !hasBg ? "background.paper" : "transparent",
                width: isPrinting ? "98%" : "auto",
            }}
            >
                <Box sx={{ display: "flex", flexDirection: "row", gap: 2, mb: 1 }}>
                    {isAnswerReport && (
                        <Box>
                            <AnswerChip item={question} />
                        </Box>
                    )}
                    {isAnswerReport && difficulty !== undefined && testMode === 1 && (
                        <Typography variant="body1" mb={2}>
                            {getDifficulty(difficulty)}
                        </Typography>
                    )}
                </Box>

                {testId && (
                    <Box mt={1} mb={2}>
                        <Typography variant="body2" color="text.disabled">{testId}_{question.id} </Typography>
                        {question.learning_standard && (
                            <Typography variant="body2" sx={{color: "text.disabled"}}>{question.learning_standard}</Typography>
                        )}
                    </Box>
                )}


                <MathJax style={{ width: "100%"}} inline >
                    {question.scenery && (
                        <>
                            <Typography variant="body2" sx={{color: "text.disabled"}}>SCENARIU</Typography>
                            <Typography
                                component="div"
                                width="100%"
                                variant="body2"
                                mb={1}
                                dangerouslySetInnerHTML={{ __html: question.scenery }}
                            />
                        </>
                    )}

                    {showEnunciation && (
                        <Box mb={2}>
                            <Typography variant="body2" sx={{color: "text.disabled"}}>
                                ENUNȚ
                            </Typography>
                            <ShowScrollBar isVisible={!isPrinting} >
                                <Typography
                                    component="div"
                                    width="100%"
                                    mb={1}
                                    variant="body2"
                                    dangerouslySetInnerHTML={{ __html: question.enunciation ?? question.q_data ?? question.q_obs }}
                                />
                            </ShowScrollBar>
                        </Box>
                    )}

                    <Grid container spacing={2}>
                        <Grid
                            item
                            xs={12}
                            md={question.illustration?.svg ? 6 : 12}
                            lg={question.illustration?.svg ? 8 : 12}
                        >
                            {showRequirement && (
                                <Typography
                                    variant="body2"
                                    sx={{color: "text.disabled"}}>
                                    CERINȚĂ
                                </Typography>
                            )}
                            <ShowScrollBar isVisible={!isPrinting} >
                                {showRequirement && (
                                    <Typography
                                        component="div"
                                        variant="body2"
                                        width="100%"
                                        mb={2}
                                        dangerouslySetInnerHTML={{ __html: question.question ?? question.q_obs }}
                                    />
                                )}

                                <Box width="fit-content" minWidth="100%">

                                    {question.q_responses && question.q_responses.map((response: any, index: number) => (
                                        <ResponseCard
                                            key={response.letter ?? index}
                                            response={response}
                                            question={question}
                                            isAnswerReport={isAnswerReport}
                                            testMode={testMode}
                                            hasBg={hasBg}
                                        />
                                    ))}

                                    {(isCustomItemPreview || isCustomItemPreviewTest) && (
                                        <>
                                            <ResponseCard
                                                key="q1"
                                                question={question.q_1}
                                                response={question.q_1}
                                                isAnswerReport={isAnswerReport}
                                                testMode={testMode}
                                                hasBg={hasBg}
                                            />
                                            <ResponseCard
                                                key="q2"
                                                question={question.q_2}
                                                response={question.q_2}
                                                isAnswerReport={isAnswerReport}
                                                testMode={testMode}
                                                hasBg={hasBg}
                                            />
                                            <ResponseCard
                                                key="q3"
                                                question={question.q_3}
                                                response={question.q_3}
                                                isAnswerReport={isAnswerReport}
                                                testMode={testMode}
                                                hasBg={hasBg}
                                            />
                                            <ResponseCard
                                                key="q4"
                                                question={question.q_4}
                                                response={question.q_4}
                                                isAnswerReport={isAnswerReport}
                                                testMode={testMode}
                                                hasBg={hasBg}
                                            />
                                        </>
                                    )}

                                </Box>
                            </ShowScrollBar>
                        </Grid>

                        {question.illustration?.svg && (
                            <Grid item xs={12} md={6} lg={4}>
                                <Box
                                    sx={{
                                        backgroundColor: "rgb(230, 230, 230)",
                                        borderRadius: "30px",
                                        position: "relative",
                                        margin: "0 0 30px 0",
                                        maxWidth: "400px"}}
                                >
                                    <img
                                        src={question.illustration.svg}
                                        alt=""
                                        style={{
                                            verticalAlign: "bottom",
                                            maxWidth: "400px",
                                            borderRadius: "30px",
                                            margin: "0 auto"}}
                                    />
                                    <Box
                                        sx={{position: "absolute",
                                            top:"-1px",
                                            left: "25%",
                                            borderRadius: "0 0 8px 8px",
                                            backgroundColor: "#fff",
                                            padding: "9px 20px 9px",
                                            fontSize: "12px",
                                            lineHeight: "10px",
                                            color: "#ADADAD",
                                            whiteSpace: "nowrap",
                                            textTransform: "uppercase"}}
                                    >
                                        Ilustrație ajutătoare
                                    </Box>
                                </Box>
                            </Grid>
                        )}

                    </Grid>
                </MathJax>

                {question.solution && isAnswerReport && (
                    <Box my={2}>
                        <Typography variant="body2" sx={{color: "text.disabled"}}>REZOLVARE</Typography>
                        <Typography
                            component="div"
                            width="100%"
                            mb={1}
                            sx={{fontSize: "0.875rem", color: "text.disabled"}}
                            dangerouslySetInnerHTML={{ __html: question.solution }}
                        />
                    </Box>
                )}

                {isCustomItemPreview && !isCustomItemPreviewTest && (
                    <Grid container spacing={1.5} alignItems="center" mt={2}>
                        <FormLabelBox title="Materie:" />
                        <FormFieldBox>{question.subject.name ?? question.subject}</FormFieldBox>
                        <FormLabelBox title="Clasa:" />
                        <FormFieldBox>{question.grade?.name ?? question.grade}</FormFieldBox>
                        <FormLabelBox title="Subcategorie:" />
                        <FormFieldBox>{question.subcategory?.name ?? question.subcategory_name}</FormFieldBox>
                        <FormLabelBox title="Raspuns corect:" />
                        <FormFieldBox>{question.right_answer}</FormFieldBox>
                    </Grid>
                )}
            </BoxContent>
        </Box>
    )
}

export default TestItemCard;